module.exports = __webpack_public_path__ + "static/img/blog_detail_1.ecea5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_detail_1.png
// module id = Dp9p
// module chunks = 8